export enum SortDirectionEnum {
    ASC = 'ACS',
    DESC = 'DESC'
}
